import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/disabling-networks/dialog-img.png",
  alt: "",
  class: "w-20rem mx-auto"
}, null, -1)
const _hoisted_3 = { class: "caption text-default" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" We will no longer support Milkomeda Cardano C1 and Cardano networks. Please withdraw your assets ")
const _hoisted_5 = { class: "white-space-nowrap" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("and bridge via ")
const _hoisted_7 = { class: "dialog-footer" }

import DisablingNetworksBanner from '@/components/disablingNetworks/DisablingNetworksBanner.vue';
import { ref } from 'vue';
import { checkIfNetworkIdDisabledToAdd } from '@/helpers/network-disable.helper';
import { DEFAULT_NETWORK_ID } from '@/helpers/networkParams.helper';
import { CHAIN_PORT_BRIDGE } from '@/constants/EXTERNAL_LINKS';
import ExternalLink from '@/components/ExternalLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisablingNetworks',
  setup(__props) {

const isDialog = ref(checkIfNetworkIdDisabledToAdd(DEFAULT_NETWORK_ID));
const onCloseDialog = () => {
  isDialog.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DisablingNetworksBanner),
    _createVNode(_component_Dialog, {
      visible: isDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isDialog).value = $event)),
      modal: true,
      header: "Blueshift is migrating to BOB!"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(ExternalLink, {
                label: "ChainPort",
                url: _unref(CHAIN_PORT_BRIDGE),
                color: "info"
              }, null, 8, ["url"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            class: "w-full button-primary",
            label: "Ok",
            onClick: onCloseDialog
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})